
import { Registration_QUESTION_TYPES, SURVEY_QUESTION_TYPES } from './types';

export const timeZones = [
	'Africa/Cairo',
	'Asia/Riyadh',
	'Asia/Dubai',
	'Asia/Muscat',
	'Asia/Bahrain',
	'Asia/Kuwait',
	// 'Africa/Abidjan',
	// 'America/Nuuk',
];
export const timeZonesOffset: any = {
	'Africa/Cairo': -120,
	'Asia/Riyadh': -180,
	'Asia/Dubai': -240,
	'Asia/Muscat': -240,
	'Asia/Bahrain': -180,
	'Asia/Kuwait': -180,
	// 'Africa/Abidjan': 0,
	// 'America/Nuuk': 180,
};
export const getDateTimeFormatOption = (): Intl.DateTimeFormatOptions => ({
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
	hour: 'numeric',
	minute: 'numeric',
	hour12: true,
});

export const formatDate = (date: string | Date) => {
	return new Intl.DateTimeFormat('en-GB', getDateTimeFormatOption()).format(new Date(date));
};

export const getIsoStringForSpecificTimeZone = (timeZone: string, dateValue: Date) => {
	const targetOffset = timeZonesOffset[timeZone];
	const date = new Date(dateValue);
	date.setMinutes(date.getMinutes() + (targetOffset - date.getTimezoneOffset()));
	return date.toISOString();
};

export const getDateForSpecificTimeZoneFromIsoString = (timeZone: string, dateValue: string | Date) => {
	const targetOffset = -1 * timeZonesOffset[timeZone];
	const date = new Date(dateValue);
	date.setMinutes(date.getMinutes() + (targetOffset + date.getTimezoneOffset()));
	return date;
};

export const personaHomePage: any = {
	Root: '/home',
	Admin: '/home',
	Usher: '/usher-home',
};

export const ALLOWED_IMAGES_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.svg', '.gif', '.webp'];

export enum ATTENDEES_EXPORT_TYPE {
	ALL = 'all',
	REGISTERS = 'registers',
	ATTENDEES = 'attendees',
}

export const SURVEY_QUESTION_TYPES_LIST = [
	{ label: 'Text', value: SURVEY_QUESTION_TYPES.TEXT },
	{ label: 'MCQ', value: SURVEY_QUESTION_TYPES.MCQ },
	{ label: 'Checkboxes', value: SURVEY_QUESTION_TYPES.CHECKBOX },
	{ label: 'Rating', value: SURVEY_QUESTION_TYPES.RATING },
];


export const REGISTERATION_QUESTION_TYPES_LIST = [
	{ label: 'Text', value: Registration_QUESTION_TYPES.TEXT },
	{ label: 'DropDown', value: Registration_QUESTION_TYPES.DropDown },
];




export const PRIMARY_KEY = '#208fdf';
export const PRIMARY_KEY_HOVER = '#208fdf80';

export const SECONDARY_KEY = '#00999d';
export const SECONDARY_KEY_HOVER = '#00999d80';


export const MAXIMUM_RETRIES_COUNT = 3

export const RECORD_PER_PAGE = 10;